import { useMemo } from 'react';
import { applyFilters } from '../../utils/emendas/filterHelpers';

export const useAdvancedFilters = (data, filters) => {
  const filteredData = useMemo(() => {
    return applyFilters(data, filters);
  }, [data, filters]);

  const activeFiltersCount = useMemo(() => {
    return Object.values(filters).filter(v => v).length;
  }, [filters]);

  return { filteredData, activeFiltersCount };
};
